interface SyncResponse {
  success: boolean;
  message: string;
  importedCount?: number;
  updatedCount?: number;
  deletedCount?: number;
  errors?: string[];
  syncId?: string;
}

interface SyncOptions {
  categoriaId?: string | null;
  deleteExisting?: boolean;
  queryParams?: Record<string, string>;
  createCategoryIfNotExists?: boolean;
  newCategoryName?: string;
}

export class SyncService {
  private static baseUrl = '/api';
  private static currentSyncController: AbortController | null = null;
  private static currentSyncId: string | null = null;

  static async syncContacts(options?: SyncOptions): Promise<SyncResponse> {
    const token = localStorage.getItem('auth_token');
    if (!token) throw new Error('Token de autenticação não encontrado. Faça login novamente.');

    const syncId = `sync-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    this.currentSyncId = syncId;
    const controller = new AbortController();
    this.currentSyncController = controller;

    try {
      const response = await fetch(`${this.baseUrl}/contatos/sync`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ ...options, syncId }),
        signal: controller.signal,
      });

      if (!response.ok) {
        const responseText = await response.text();
        let errorMessage = 'Erro ao sincronizar contatos';
        try {
          const errorData = JSON.parse(responseText);
          errorMessage = errorData.error || errorData.message || errorData.details || errorMessage;
        } catch {
          errorMessage = responseText || response.statusText;
        }
        throw new Error(errorMessage);
      }

      const result = await response.json();
      this.currentSyncController = null;
      this.currentSyncId = null;
      return result;
    } catch (error: any) {
      this.currentSyncController = null;
      this.currentSyncId = null;
      if (error.name === 'AbortError') throw new Error('Sincronização cancelada pelo usuário');
      throw error;
    }
  }

  static async cancelSync(): Promise<boolean> {
    const syncId = this.currentSyncId;
    if (!syncId) return false;
    const token = localStorage.getItem('auth_token');
    if (this.currentSyncController) this.currentSyncController.abort();
    try {
      const response = await fetch(`${this.baseUrl}/contatos/sync/cancel`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ syncId }),
      });
      if (response.ok) {
        this.currentSyncController = null;
        this.currentSyncId = null;
        return true;
      }
    } catch {
      this.currentSyncController = null;
      this.currentSyncId = null;
    }
    return false;
  }
}
